import SupportIcon from './component'

export default SupportIcon
